module.exports = __webpack_public_path__ + "img/meta_en.1ddf42b.jpg";